import React from 'react'

import { useTranslation } from 'react-i18next'
import { HashLink } from 'react-router-hash-link'

import { DiscoverMoreButton } from '../../../components/buttons/DiscoverMoreButton'
import { InfoCard } from '../../../components/InfoCard'
import { SectionText } from '../../../components/SectionText'

interface ServicesProps {
    className?: string
}

export const Services: React.FC<ServicesProps> = ({ className }) => {
    const { t } = useTranslation()
    const services = t('landingPage.services.servicesList', { returnObjects: true }) as string[]
    const description = t('landingPage.services.description').split('\n')

    return (
        <div
            id="services"
            className={`${className} flex justify-between h-auto min-h-[600px] w-full text-white bg-primary-green
            sm:flex-col sm:px-5 sm:py-3 sm:min-h-[900px]
        `}>
            <div
                className="w-2/3 h-full flex items-center justify-center
                sm:w-full sm:h-2/5 sm:px-5 sm:py-5
            ">
                <SectionText
                    className="max-w-[500px] h-auto max-h-full"
                    title={t('landingPage.services.title')}
                    hrLineColor="bg-primary-blue"
                    discoverMore={false}>
                    {description.map((line, index) => (
                        <p key={index}>{line}</p>
                    ))}
                </SectionText>
            </div>
            <div
                className="w-1/3 h-full flex items-center justify-center flex-col
                sm:w-full sm:h-3/5 sm:mt-5
            ">
                {services.map((value, index) => {
                    return (
                        <div key={index} className="mt-4 flex justify-center items-center w-full">
                            <h1 className="text-[40px] mr-5">{index + 1}</h1>
                            <InfoCard className="w-4/5 bg-secondary-green">
                                <HashLink
                                    to={index < 2 ? '/services#SurgeryAndAmbulant' : '/services#OrthopedicAndEmergency'}
                                    className="hover:text-primary-blue">
                                    {value}
                                </HashLink>
                            </InfoCard>
                        </div>
                    )
                })}
                <DiscoverMoreButton className="my-4 bg-primary-orange justify-end ml-[45px]" link="services" />
            </div>
        </div>
    )
}
